<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m12.487 19.59-4.513-.083c-1.462-.03-2.927.028-4.36-.27-2.179-.445-2.333-2.628-2.495-4.46a31.284 31.284 0 0 1 .284-7.748c.237-1.433 1.17-2.287 2.614-2.38 4.872-.338 9.777-.298 14.64-.14.513.014 1.03.093 1.536.183 2.5.438 2.56 2.912 2.722 4.994a28.32 28.32 0 0 1-.215 6.31c-.248 1.73-.722 3.18-2.722 3.32-2.507.184-4.956.331-7.47.284.001-.01-.013-.01-.02-.01Zm-2.653-4.381c1.889-1.085 3.741-2.151 5.62-3.229-1.893-1.084-3.742-2.15-5.62-3.228v6.457Z"
      fill="currentColor"
    />
  </svg>
</template>
